import React, { Component, Fragment } from 'react';
import RadioModifierContent from './RadioModifierContent';
import DropdownModifierContent from "./DropdownModifierContent";
export default class ItemStyles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRadios: [],
            hideChangeSelectionBtn: true
        };
        this.generateJSXFromData = this.generateJSXFromData.bind(this);
        this.selectRadio = this.selectRadio.bind(this);
        this.showChangeSelectionBtn = this.showChangeSelectionBtn.bind(this);
    }

    UNSAFE_componentWillMount() {
        let freshSelectedRadios = this.props.modifierGroups.map( (val,ind,arr) => {
            let selection = 0;
            val.modifiers.forEach(mod => {
                if(this.props.choices[mod].quantity >= 1) {
                    selection = mod;
                }
            });
            return selection;
        });
        this.setState({selectedRadios: freshSelectedRadios});
    }

    showChangeSelectionBtn() {
        this.setState({
            hideChangeSelectionBtn: false
        })
    }

    showChangeSelectionDivs() {
        $('.special-radio').each(function() {
            $(this).show();
        });
    }

    selectRadio(index, id) {
        let selected = this.state.selectedRadios;
        selected[index] = id;
        this.setState({selectedRadios: selected}, () => {
            let isNowValid = true;
            this.state.selectedRadios.map( (val,ind,arr) => {
                if(val === 0) {
                    isNowValid = false;
                }
            });
            if(isNowValid) {
                this.props.markAsValid()
            }
        });
    }

    // generateJSXFromData() {
    //     var result = this.props.modifierGroups.map( (val,ind,arr) => {
    //         return <RadioModifierContent name={val.name} key={ind} modifiers={val.modifiers} allModifiers={this.props.allModifiers}
    //                 setWhole={this.props.setWhole} setExtra={this.props.setExtra} setLight={this.props.setLight}
    //                 setNormal={this.props.setNormal} removeModifier={this.props.removeModifier} choices={this.props.choices}
    //                 radioIndex={ind} selectRadio={this.selectRadio} showChangeSelectionBtn={this.showChangeSelectionBtn} />
    //     });
    //     return result;
    // }

    generateJSXFromData() {
        var result = this.props.modifierGroups.map( (val,ind,arr) => {
            return <DropdownModifierContent
                        name={val.name}
                        key={ind}
                        modifiers={val.modifiers}
                        allModifiers={this.props.allModifiers}
                        setWhole={this.props.setWhole}
                        setExtra={this.props.setExtra}
                        setLight={this.props.setLight}
                        setNormal={this.props.setNormal}
                        removeModifier={this.props.removeModifier}
                        choices={this.props.choices}
                        radioIndex={ind}
                        selectRadio={this.selectRadio}
                        itemGroup={this.props.itemGroup}
                        selectedMainItem={this.props.selectedMainItem}
                        // showChangeSelectionBtn={this.showChangeSelectionBtn}
                    />
        });
        return result;
    }

    render() {
        let jsx = this.generateJSXFromData();
        return (
            this.props.isSpecial ?
                <div className={"container"}>
                    {jsx}
                </div>
                :
            // Only return this section if it's not blank
            jsx.length > 0 ?
                <div className="col m-auto pb-2">
                    <Fragment>
                        <div className='col'>
                            {jsx}
                        </div>
                    </Fragment>
                    <div className="row">
                        <div className="col">
                        </div>
                        <div className="col">
                            <button className="btn btn-primary"
                                    hidden={this.state.hideChangeSelectionBtn}
                                    onClick={this.showChangeSelectionDivs}
                            >
                                Change Selection
                            </button>
                        </div>
                        <div className="col">
                        </div>
                    </div>
                </div>
                    : ''
        );
    }
}
